import {useState} from "react";
import {useTranslation} from "react-i18next";

import {ComboboxGeneric} from "@/components/ui/combobox-generic";
import {getStorageItem} from "@/src/modules/core/lib";

import {tIncidentTypeName} from "../lib/incident-type-i18n";
import {IncidentReportType} from "../types";

type IncidentTypeComboboxProps = {
  value: IncidentReportType | null;
  onChange: (value: IncidentReportType | null) => void;
};

export function IncidentTypeCombobox({value, onChange}: IncidentTypeComboboxProps) {
  const {t: tCommon} = useTranslation("common");
  const [incidentReportTypes] = useState<IncidentReportType[]>(
    getStorageItem("incidentReportTypes"),
  );

  return (
    <ComboboxGeneric<IncidentReportType>
      items={incidentReportTypes}
      value={value}
      onChange={onChange}
      getItemKey={(item) => `incident-type-${item.incident_report_type_id}`}
      getItemLabel={(item) => tIncidentTypeName(item.type, tCommon)}
      isItemEqual={(item, selected) =>
        item.incident_report_type_id === selected?.incident_report_type_id
      }
      placeholder={tCommon("select_type")}
      emptyMessage="No items found."
    />
  );
}
